import { IFilterValues, ICustomersContext } from './customersContext';

export enum CustomersActionTypes {
	SET_CUSTOMERS = 'SET_CUSTOMERS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_CLIENT_TYPE = 'SET_CLIENT_TYPE',
	SET_STATUS = 'SET_STATUS',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ARCHIVING = 'SET_ID_FOR_ARCHIVING',
	SET_ID_FOR_RESTORING = 'SET_ID_FOR_RESTORING',
	SET_FULL_INFO_DATA = 'SET_FULL_INFO_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetCustomers {
	type: CustomersActionTypes.SET_CUSTOMERS;
	payload: {
		customers: ICustomersContext['customers'];
		typeOfModalWindow: ICustomersContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: CustomersActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: ICustomersContext['searchString'];
	};
}

interface ISetClientType {
	type: CustomersActionTypes.SET_CLIENT_TYPE;
	payload: {
		selectedClientType: ICustomersContext['selectedClientType'];
	};
}

interface ISetStatus {
	type: CustomersActionTypes.SET_STATUS;
	payload: {
		status: ICustomersContext['status'];
	};
}

interface IResetSelectedControls {
	type: CustomersActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: CustomersActionTypes.SET_SORT_BY;
	payload: {
		sortBy: ICustomersContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: CustomersActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: ICustomersContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: CustomersActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: ICustomersContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: CustomersActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: ICustomersContext['IDForDeletion'];
		typeOfModalWindow: ICustomersContext['typeOfModalWindow'];
	};
}

interface ISetIDForArchiving {
	type: CustomersActionTypes.SET_ID_FOR_ARCHIVING;
	payload: {
		IDForArchiving: ICustomersContext['IDForArchiving'];
		typeOfModalWindow: ICustomersContext['typeOfModalWindow'];
	};
}

interface ISetIDForRestoring {
	type: CustomersActionTypes.SET_ID_FOR_RESTORING;
	payload: {
		IDForRestoring: ICustomersContext['IDForRestoring'];
		typeOfModalWindow: ICustomersContext['typeOfModalWindow'];
	};
}

interface ISetFullInfoData {
	type: CustomersActionTypes.SET_FULL_INFO_DATA;
	payload: {
		fullInfoData: ICustomersContext['fullInfoData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CustomersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICustomersContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: CustomersActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TCustomersAction =
	| ISetCustomers
	| IChangeSearchString
	| ISetClientType
	| ISetStatus
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForArchiving
	| ISetIDForRestoring
	| ISetFullInfoData
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
